<template>
    <div class="page case-list">
        <list-skeleton v-if="pageLoading" style="margin-bottom: 100vh"></list-skeleton>
        <div v-else>
            <div class="case-list-search">
                <van-search class="top-search" v-model="value">
                    <template v-slot:left-icon>
                        <img src="/static/v4/search_icon.svg" alt="" style="margin-top: 2px" />
                    </template>
                </van-search>
                <div class="case-list-search-swiper">
                    <van-swipe style="height: 36px;line-height: 36px" :autoplay="3000" vertical :show-indicators="false">
                        <van-swipe-item v-for="(item, index) in search_placeholder" :key="index" @click="jump(item)">
                            {{ item.title }}
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>

            <div class="tags">
                <van-tabs v-model="category_index" @click="changeCategory" swipeable>
                    <van-tab :title-class="'course-list-category-title'" v-for="item in categories" :key="item.id" :title="item.title" />
                </van-tabs>
                <div class="clear"></div>
            </div>

            <div class="case-list-swiper" v-if="bannerList && bannerList.length && category_index === 0">
                <van-swipe :autoplay="10000">
                    <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="goImageClick(item)">
                        <van-image :src="item.img" fit="cover"></van-image>
                    </van-swipe-item>
                </van-swipe>
            </div>

            <div class="recommend-list" v-if="category_index === 0">
                <div v-if="recommendList && recommendList !== null && recommendList.length > 0">
                    <van-list
                        v-if="recommendList"
                        v-model="recommendLoading"
                        :finished="recommendFinished"
                        :immediate-check="false"
                        finished-text="已到底部"
                        @load="onRecommendLoad"
                    >
                        <Article
                            v-for="item in recommendList"
                            :key="item.id"
                            :dataItem="item"
                            :wapperFn="true"
                            @goDetail="goDetail(item)"
                            @hadnleStatus="hadnleStatus(item)"
                        />
                    </van-list>
                </div>

                <van-empty v-else description="" image="/static/img/pic_blank_content.svg">
                    <template slot="description">
                        <div style="text-align: center">没有更多了</div>
                        <div style="text-align: center">博医荟持续更新中…</div>
                        <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                        <div style="text-align: center;margin-top: 24px">
                            <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                                返回首页
                            </van-button>
                        </div>
                    </template>
                </van-empty>
            </div>

            <div class="channel-list" v-else>
                <div v-if="channelList && channelList !== null && channelList.length > 0">
                    <van-list
                        v-if="channelList"
                        v-model="channelLoading"
                        :finished="channelFinished"
                        :immediate-check="false"
                        finished-text="已到底部"
                        @load="onChannelLoad"
                    >
                        <Article
                            v-for="item in channelList"
                            :key="item.id"
                            :dataItem="item"
                            :wapperFn="true"
                            @goDetail="goDetail(item)"
                            @hadnleStatus="hadnleStatus(item)"
                        />
                    </van-list>
                </div>

                <van-empty v-else description="" image="/static/img/pic_blank_content.svg">
                    <template slot="description">
                        <div style="text-align: center">没有更多了</div>
                        <div style="text-align: center">博医荟持续更新中…</div>
                        <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                        <div style="text-align: center;margin-top: 24px">
                            <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                                返回首页
                            </van-button>
                        </div>
                    </template>
                </van-empty>
            </div>
        </div>

        <Back></Back>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import listSkeleton from '@/skeleton/listSkeleton'
import Back from '../components/back.vue'
import Article from '../components/article'
export default {
    name: 'case-list',
    components: {
        'list-skeleton': listSkeleton,
        Back,
        Article
    },
    data() {
        return {
            value: '',
            active: '',
            category_id: 0,
            category_index: 0,
            category_child_id: 0,
            bannerList: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            pageLoading: true,
            channelList: [],
            channelLoading: false,
            channelFinished: false,
            channePage: {
                page: 1,
                pageSize: 10
            },
            channeTotal: 0,
            recommendTotal: 0,
            type: false,
            pageID: null,
            search_placeholder: [],
            recommendList: [],
            recommendLoading: false,
            recommendFinished: false,
            recommendPage: {
                page: 1,
                pageSize: 10
            }
        }
    },

    methods: {
        goDetail(row) {
            let params = this.category_index == 0 ? row.id : row.origin_id
            if (row.type === 2) {
                this.$router.push({ name: 'article-column', params: { id: params } })
                Interface.getShareBaseInfo(this, '病例实战-' + row.title, '', '')
            } else {
                Interface.goArticle(this, row, false)
                Interface.getShareBaseInfo(this, '病例实战-' + row.title, '', '')
            }
        },
        hadnleStatus(row) {
            if (!row.is_subscribe) {
                this.pageID = row.id
                this.fetch('subscribe')
                return
            }
            this.$dialog
                .confirm({
                    title: '提醒',
                    message: '确定取消关注吗？',
                    confirmButtonText: '确定',
                    className: 'dly-dialog'
                })
                .then(() => {
                    this.type = true
                    this.pageID = row.id
                    this.fetch('subscribe')
                })
                .catch(() => {
                    console.log(1)
                })
        },
        goImageClick(row) {
            if (row.target_url) {
                window.location.href = row.target_url
                Interface.mFootPrint(row.id,33,0,4,0, row.title)
            }
        },
        // 跳转到搜索页面
        jump(item) {
            let search = JSON.stringify(item)
            this.$router.push({ path: '/search-new', query: { search: search,channel:"case" } })
        },
        onChannelLoad() {
            this.channelFinished = false
            this.channelLoading = true
            this.channePage.page++
            this.fetch('channelList-more')
        },
        onRecommendLoad() {
            this.recommendFinished = false
            this.recommendLoading = true
            this.recommendPage.page++
            this.fetch('recommendList-more')
        },

        fetch(scene) {
            // tab 推荐
            if (scene === 'category') {
                Interface.getData('get', '/course/api/channel', { origin_type: 6 }).then(res => {
                    this.categories = res.data.list
                    this.categories.unshift({ title: '推荐', id: 0 })
                    if (this.categories.length < 5) {
                        for (let i = 999; i <= 1007 - this.categories.length; i++) {
                            this.categories.push({
                                title: '',
                                id: Math.random().toString(16).slice(2)
                            })
                        }
                    }
                })
            } else if (scene === 'recommendList') {
                // 推荐使用的 列表数据
                Interface.getData('get', '/course/api/article/list', { content_type: 6, page:this.recommendPage.page,pageSize:this.recommendPage.pageSize}).then(res => {
                    if (res.code === 0) {
                        this.recommendList = res.data.list
                        this.recommendLoading = false
                    }

                    if (res.data.page >= res.data.total_page || this.recommendList.length >= res.data.total) {
                        this.recommendFinished = true
                    }
                    setTimeout(() => {
                        this.pageLoading = false
                    }, 500)
                })
            } else if (scene === 'channelList') {
                // 其他tab 使用的列表
                Interface.getData('get', `/course/api/channel/${this.category_id}`, { origin_type: 6, ...this.channePage }).then(res => {
                    if (res.code === 0) {
                        this.channelList = res.data.list
                        // 加载状态结束
                        this.loading = false
                    }

                    if (res.data.page >= res.data.total_page || this.channelList.length >= res.data.total) {
                        this.channelFinished = true
                    }

                    setTimeout(() => {
                        this.pageLoading = false
                    }, 500)
                })
            } else if (scene === 'bannerList') {
                Interface.getData('get', '/course/api/banner/list', { type: 9 }).then(res => {
                    if (res.code === 0) {
                        this.bannerList = res.data
                    }
                })
            } else if (scene === 'subscribe') {
                Interface.getData('get', Interface.medical.subscribe + this.pageID).then(res => {
                    if (res.code === 0) {
                        if (this.type) {
                            this.$toast.success('取消关注成功')
                            this.type = false
                            this.pageID = null
                        } else {
                            this.$toast.success('关注成功')
                        }
                        this.page = { page: 1, pageSize: 10 }
                        if (this.category_index === 0) {
                            this.fetch('recommendList')
                        } else {
                            this.fetch('channelList')
                        }
                        this.channelList = []
                    } else {
                        this.$toast(res.message)
                    }
                })
            } else if (scene === 'search_text') {
                // 获取底纹词
                Interface.getData('get', Interface.v4.search_list, { type: 2 }).then(res => {
                    if (res.code == 0) {
                        this.search_placeholder = res.data.hot_words
                    }
                })
            } else if (scene === 'channelList-more') {
                // 其他tab 使用的列表
                Interface.getData('get', `/course/api/channel/${this.category_id}`, { origin_type: 6, ...this.channePage }).then(res => {
                    if (res.code === 0) {
                        console.log(res.data.list)
                        if (res.data.list === null) {
                            this.channelFinished = true
                            return
                        }
                        this.channelList = [...this.channelList, ...res.data.list]
                        // 加载状态结束
                        this.channelLoading = true

                        if (res.data.page >= res.data.total_page || this.channelList.length >= res.data.total) {
                            this.channelFinished = true
                        }
                    }
                })
            } else if (scene === 'recommendList-more') {
                // 推荐使用的 列表数据
                console.log(this.recommendPage, 'adhsahda')
                Interface.getData('get', '/course/api/article/list', { content_type: 6, ...this.recommendPage }).then(res => {
                    if (res.code === 0) {
                        console.log(res.data.list)
                        if (res.data.list === null) {
                            this.recommendFinished = true
                            return
                        }
                        this.recommendList = [...this.recommendList, ...res.data.list]
                        // 加载状态结束
                        this.recommendLoading = false

                        if (res.data.page >= res.data.total_page || this.recommendList.length >= res.data.total) {
                            this.recommendFinished = true
                        }
                    }
                })
            }
        },
        changeCategory() {
            this.category_id = this.categories[this.category_index].id
            if (this.category_index === 0) {
                this.fetch('recommendList')
            } else {
                this.fetch('channelList')
            }
            Interface.getShareInfo(this, '病例实战-' + this.categories[this.category_index].title,'', "同行病例实战经验分享，扩宽诊疗思路", false)
            if (this.category_id) {
                Interface.mFootPrint(this.category_id,32,0,4,0, this.categories[this.category_index].title)
            }
        },
        goArticle(item) {
            if (item.type == 1) {
                this.$router.push({ name: 'article-detail', params: { id: item.content_id }, query: { content_type: 6 } })
            } else {
                this.$router.push({ name: 'article-column', params: { id: item.content_id }, query: { content_type: 6 } })
            }
        },
        go_video(item) {
            if (item.type === 1) {
                this.$router.push({ name: 'video-detail', params: { id: item.content_id }, query: { content_type: 6 } })
            } else {
                this.$router.push({ name: 'video-column', params: { id: item.content_id }, query: { content_type: 6 } })
            }
        },
    },
    created() {
        this.fetch('category')
        this.fetch('bannerList')
        this.fetch('search_text')
        Interface.getShareInfo(this, '病例实战', '', '同行病例实战经验分享，扩宽诊疗思路', 40)
        sessionStorage.removeItem('search_data')
        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint(0, 40,'', 4, source_type, '病例实战')
        } else {
            Interface.mFootPrint('',40,'',4,0, '病例实战')
        }
        if (this.category_index === 0) {
            this.fetch('recommendList')
        } else {
            this.fetch('channelList')
        }
    },
}
</script>
<style lang="scss">
@import './index';
</style>



// WEBPACK FOOTER //
// src/views/case/list/index.vue